module.exports = __webpack_public_path__ + "static/media/winSmall120_1.b91f3d6d.svg";